/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { deviceApiSlice } from "../../api/devices/deviceApiSlice";
import {
  buildDeviceFilterAction,
  setSelectedDeviceSiteGroupAction,
  setSelectedDeviceNameAction,
  setSelectedDeviceSiteAction,
  setSelectedDeviceStatusAction,
  setSelectedDeviceTypeAction,
  setSelectedConfigGroupAction,
  setSelectedDeviceConfigStatusAction,
  setSelectedSeverityTypeAction,
  setSelectedDeviceVersionAction,
  resetDeviceFiltersAction,
  setMaintenanceModeAction,
  setSelectedDeviceKpiAction,
  setSelectedLabelsAction,
  setRegionFilterIdsAction,
} from "./actions";
import { IDeviceFilterState } from "../types";

const initialState: IDeviceFilterState = {
  deviceTypes: [],
  deviceHostNames: [],
  regionFilterIds: [],
};

const deviceFilterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    buildDeviceFilter: buildDeviceFilterAction,
    setSelectedDeviceSiteGroup: setSelectedDeviceSiteGroupAction,
    setSelectedDeviceName: setSelectedDeviceNameAction,
    setSelectedDeviceType: setSelectedDeviceTypeAction,
    setSelectedSeverityType: setSelectedSeverityTypeAction,
    setSelectedDeviceSite: setSelectedDeviceSiteAction,
    setSelectedDeviceStatus: setSelectedDeviceStatusAction,
    setSelectedConfigGroup: setSelectedConfigGroupAction,
    setSelectedDeviceConfigStatus: setSelectedDeviceConfigStatusAction,
    setSelectedDeviceVersion: setSelectedDeviceVersionAction,
    resetDeviceFilters: resetDeviceFiltersAction,
    setMaintenanceMode: setMaintenanceModeAction,
    setSelectedDeviceKpiStatus: setSelectedDeviceKpiAction,
    setSelectedLabels: setSelectedLabelsAction,
    setRegionFilterIds: setRegionFilterIdsAction,
  },
  extraReducers: (builder) => {
    // Every time the list of devices updates, the list of unique hostNames will also update.
    // We need this for the filter select boxes
    builder.addMatcher(deviceApiSlice.endpoints.getNodes.matchFulfilled, (state, { payload }) => {
      //buildDeviceFilterAction(state, { type: "Build", payload: payload });
    });
  },
});

export const DeviceFilterReducer = deviceFilterSlice.reducer;
export const {
  setSelectedDeviceSiteGroup,
  setSelectedDeviceName,
  setSelectedDeviceSite,
  setSelectedDeviceStatus,
  setSelectedDeviceType,
  setSelectedConfigGroup,
  setSelectedDeviceConfigStatus,
  setSelectedSeverityType,
  setSelectedDeviceVersion,
  resetDeviceFilters,
  setMaintenanceMode,
  setSelectedDeviceKpiStatus,
  setSelectedLabels,
  setRegionFilterIds,
} = deviceFilterSlice.actions;
